//////////////////////////////////////////////////////////////////////////////
//
//  ProtectedRoute Component
//
//  작성자: MediInStep Team
//  생성일: 2025-01-XX
//
//  설명: 인증이 필요한 라우트 보호 컴포넌트
//       - 토큰이 있으면 접근 허용
//       - 토큰이 없으면 로그인 페이지로 리다이렉트
//
//////////////////////////////////////////////////////////////////////////////

import { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { getStoredAccessToken } from "Shared/Utils/CredentialStorage";

interface ProtectedRouteProps {
  children: ReactNode;
}

/**
 * 인증이 필요한 라우트 보호 컴포넌트
 */
const ProtectedRoute = ({ children }: ProtectedRouteProps) => {
  const token = getStoredAccessToken();

  // 토큰이 없으면 로그인 페이지로 리다이렉트
  if (!token) {
    return <Navigate to="/authentication/sign-in/basic" replace />;
  }

  // 토큰이 있으면 자식 컴포넌트 렌더링
  return <>{children}</>;
};

export default ProtectedRoute;

